import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { IDriveContent } from 'src/@types/drive';
import { DriveRequests } from 'src/requests/drive';

type addFilePayload = { file: File; parentId?: string };

export const useImageUpload = () => {
  const { mutateAsync: addFile, isLoading: isAddingFile } = useMutation(
    ({ file, parentId }: addFilePayload) =>
      DriveRequests.addFile({ file, parent: parentId }),
  );

  const addImageFile = useCallback(
    async ({ file, parentId }: addFilePayload): Promise<IDriveContent> => {
      return await addFile({ file, parentId });
    },
    [addFile],
  );

  const { mutateAsync: getUrl, isLoading: isGettingUrl } = useMutation(
    (fileId: string) => DriveRequests.getDownloadUrl(fileId),
  );

  const getImageUrl = useCallback(
    async (fileId: string): Promise<{ url: string }> => {
      return await getUrl(fileId);
    },
    [getUrl],
  );

  const { mutateAsync: getBgImages, isLoading: isGettingImages } = useMutation(
    (folderId: string) =>
      DriveRequests.getContents({ parent: folderId, signedUrl: true }),
  );

  const getImages = useCallback(
    async (folderId: string): Promise<IDriveContent[]> => {
      return await getBgImages(folderId);
    },
    [getBgImages],
  );

  return {
    getImages,
    isGettingImages,
    getImageUrl,
    isGettingUrl,
    addImageFile,
    isAddingFile,
  };
};
